import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { IconEmoji } from './IconEmoji';
const DefaultEmoji = 'speech_balloon';
export const EntityImage = ({ entity, size = 'md', defaultIcon: Icon, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const sizeClsx = [
        size === 'xxs' && 'h-4 w-4',
        size === 'xs' && 'h-6 w-6',
        size === 'xsm' && 'h-8 w-8',
        size === 'sm' && 'h-10 w-10',
        size === 'md' && 'h-16 w-16',
        size === 'lg' && 'h-24 w-24',
    ];
    const sizeInPixel = {
        xxs: 16,
        xs: 24,
        xsm: 32,
        sm: 40,
        md: 64,
        lg: 96,
    };
    const emojiSizeMap = {
        xxs: 'xs',
        xs: 'xs',
        xsm: 'sm',
        sm: 'md',
        md: 'lg',
        lg: '2xl',
    };
    if ((_a = entity === null || entity === void 0 ? void 0 : entity.image) === null || _a === void 0 ? void 0 : _a.url) {
        return (_jsx("div", { className: clsx('flex items-center justify-center', sizeClsx), children: _jsx("img", { alt: entity.name, className: clsx('text-content-subdued group-hover:text-content-hovered object-scale-down', 'flex-shrink-0 rounded-md', sizeClsx, size === 'lg' ? 'rounded-md p-1' : ''), width: sizeInPixel[size] || 24, height: sizeInPixel[size] || 24, "aria-hidden": "true", src: size === 'lg' || size === 'md'
                    ? (_c = (_b = entity === null || entity === void 0 ? void 0 : entity.image) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.small
                    : (_e = (_d = entity === null || entity === void 0 ? void 0 : entity.image) === null || _d === void 0 ? void 0 : _d.urls) === null || _e === void 0 ? void 0 : _e.thumb }, void 0) }, void 0));
    }
    if ((_f = entity.image) === null || _f === void 0 ? void 0 : _f.text) {
        return (_jsx("div", { className: clsx('text-content-subdued group-hover:text-content-hovered', 'flex items-center justify-center cursor-default', sizeClsx), children: _jsx(IconEmoji, { text: ((_g = entity === null || entity === void 0 ? void 0 : entity.image) === null || _g === void 0 ? void 0 : _g.text) || DefaultEmoji, size: emojiSizeMap[size] }, void 0) }, void 0));
    }
    return (_jsx("div", { className: clsx('text-content-subdued group-hover:text-content-hovered', 'flex items-center justify-center cursor-default', sizeClsx), children: Icon ? (_jsx(Icon, { className: clsx(sizeClsx) }, void 0)) : (_jsx(IconEmoji, { text: DefaultEmoji, size: emojiSizeMap[size] }, void 0)) }, void 0));
};
//# sourceMappingURL=EntityImage.js.map